export default "__VITE_ASSET__DpBQNKme__"